"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showOnHoverScrollbarStyle = exports.baseScrollbarStyle = exports.ShadowWrapper = exports.Shadow = exports.Scrollbar = exports.OverflowScroller = exports.OverflowContent = exports.Detector = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
const baseScrollbarStyle = exports.baseScrollbarStyle = (0, _styledComponents.css)`
  @supports (-moz-appearance: none) {
    & {
      scrollbar-width: thin;
      scrollbar-color: #a8a8a8 transparent;
      
      &:hover {
        scrollbar-color: #a8a8a8 transparent; 
      }
      &:active {
        scrollbar-color: #787878 transparent;
      }
    }
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    position: relative;
    z-index: 99999;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 5px;
  }
  &:hover::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a8a8a8;
    border-radius: 5px;
    border: 1px solid transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    border: 1px solid transparent;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888888;
  }
  &::-webkit-scrollbar-thumb:active {
    background-color: #353535;
  }
`;
const showOnHoverScrollbarStyle = exports.showOnHoverScrollbarStyle = (0, _styledComponents.css)`
  ${baseScrollbarStyle}

  @supports (-moz-appearance: none) {
    & {
      scrollbar-color: transparent transparent;
    }
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background-color: #a8a8a8;
  }

`;
const Scrollbar = exports.Scrollbar = _styledComponents.default.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
const OverflowContent = exports.OverflowContent = _styledComponents.default.div`
  display: inline-block;
  position: relative;
`;
const Detector = exports.Detector = _styledComponents.default.div`
  --detector-size: 10px;

  display: block;
  position: absolute;
`;
const ShadowWrapper = exports.ShadowWrapper = _styledComponents.default.div`
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  pointer-events: none;
`;
const Shadow = exports.Shadow = _styledComponents.default.div`
  --gradient-starting-color: rgba(0, 0, 0, 0);
  --gradient-ending-color: rgba(0, 0, 0, 0.85);
  --gradient-size: 50px;
  --gradient-direction: 0deg;
  --gradient-scroll-gutter: 0px;

  @media (pointer: fine) {
    --gradient-scroll-gutter: 8px;
  }


  background: linear-gradient(var(--gradient-direction), var(--gradient-starting-color) 0%, var(--gradient-ending-color) 100%);
  position: absolute;
  pointer-events: none;
`;
const OverflowScroller = exports.OverflowScroller = _styledComponents.default.div`
  max-height: var(--overflow-max-height, unset);
  max-width: var(--overflow-max-width, unset);
  width: 100%;
  height: 100%;
  overflow: auto;
`;